import Vue from 'vue';
import Router from 'vue-router';
import NotFound from '../views/not_found.vue';
import admin from './admin';
import judge from './judge';
import committee from './committee';
import front from './front';
import frontTemplate from '../views/front/template.vue';
import adminTemplate from '../views/admin/template.vue';
import judgeTemplate from '../views/judge/template.vue';
import committeeTemplate from '../views/committee/template.vue';
import routeView from '../views/route.vue';
import store from '../store';

Vue.use(Router);

const authorities = 'kcl|ktc|ktr|kilt|fiti';

const router = new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ selector: to.hash, offset: { y: 100 } });
        }, 500);
      });
    }
    if (savedPosition) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(savedPosition);
        }, 100);
      });
    }
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/', component: routeView },
    { path: '/admin', component: routeView },
    { path: '/judge', component: routeView },
    { path: '/committee', component: routeView },
    { path: '/404', component: NotFound },
    { path: '/403', component: NotFound },

    {
      path: `/:site(${authorities})/admin`,
      component: adminTemplate,
      children: admin,
    },
    {
      path: `/:site(${authorities})/judge`,
      component: judgeTemplate,
      children: judge,
    },
    {
      path: `/:site(${authorities})/committee`,
      component: committeeTemplate,
      children: committee,
    },
    {
      path: `/:site(${authorities})`,
      component: frontTemplate,
      children: front,
    },

    { path: '*', redirect: '/404' },
  ],
});


router.beforeEach((to, from, next) => {
  const role = to.matched.reduce((a, record) => `${a}${record.meta.requireRole || ''}`, '');
  if (role && store.state.site) {
    if (role.indexOf('COMPANY') > -1) {
      if (store.state.authentication && store.state.authentication.role === 'C') {
        next();
      } else {
        store.commit('openLogin', to.path);
        next(false);
      }
    } else if (role.indexOf('AUTHORITY') > -1) {
      if (store.state.authentication && store.state.authentication.role === 'A') {
        next();
      } else {
        next({ path: `/${store.state.site}/admin/login` });
      }
    } else if (role.indexOf('JUDGE') > -1) {
      if (store.state.authentication && store.state.authentication.role === 'J') {
        next();
      } else {
        next({ path: `/${store.state.site}/judge/login` });
      }
    } else {
      next(false);
    }
  } else {
    next();
  }
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js